<template>
  <v-data-table
    :headers="headers"
    :items="uploads"
    :items-per-page="20"
    v-bind="$attrs"
  >
    <template #[`item.filename`]="{ item }">
      <a
        :href="item.url"
        target="_blank"
      >
        {{ item.filename }}
      </a>
    </template>
    <template #[`item.used`]="{ item }">
      <span v-if="item.used">
        <v-icon small>
          mdi-check
        </v-icon>
      </span>
    </template>
    <template #[`item.thumbnail`]="{ item }">
      <div class="d-flex">
        <img
          v-if="item.type === 'image'"
          :src="item.url"
          style="max-width: 100%; height: 40px;"
        >
        <v-icon
          v-else-if="item.type === 'pdf'"
          :size="40"
        >
          mdi-file-pdf
        </v-icon>
      </div>
    </template>
    <template #[`item.actions`]="{ item }">
      <v-btn
        small
        icon
        :data-clipboard-text="item.url"
        :title="$t('Copy URL')"
        class="copy-btn"
      >
        <v-icon small>
          mdi-content-copy
        </v-icon>
      </v-btn>
      <v-btn
        small
        icon
        :title="$t('Edit')"
        @click="editItem(item)"
      >
        <v-icon small>
          mdi-pencil
        </v-icon>
      </v-btn>
      <v-btn
        small
        icon
        :title="$t('Delete')"
        @click="deleteItem(item)"
      >
        <v-icon small>
          mdi-delete
        </v-icon>
      </v-btn>
    </template>
  </v-data-table>
</template>

<script>
export default {
  props: {
    uploads: {
      type: Array,
      required: true
    }
  },

  data() {
    return {
      clipboard: null,
      headers: [
        { text: this.$t('Title'), value: 'title' },
        { text: this.$t('Filename'), value: 'filename' },
        { text: this.$t('Thumbnail'), value: 'thumbnail', sortable: false },
        { text: this.$t('Size'), value: 'size' },
        { text: this.$t('Type'), value: 'type' },
        { text: this.$t('In use'), value: 'used' },
        { text: this.$t('Actions'), value: 'actions', sortable: false },
      ]
    }
  },

    mounted() {
      this.initializeClipboardJs();
    },

  methods: {
    initializeClipboardJs() {
      this.clipboard = new window.ClipboardJS('.copy-btn');

      this.clipboard.on('success', e => {
        this.$root.$snack('success', this.$t('URL copied to clipboard'), 1500);
        e.clearSelection();
      });

      this.clipboard.on('error', () => {
        this.$root.$snack('error', this.$t('Could not copy URL to clipboard'), 1500);
      });
    },

    async deleteItem(item) {
      const confirmed = await this.$root.$confirm(
        this.$t('Remove file'), this.$t('Are you sure you want to continue?')
      );

      if (confirmed) {
        this.$inertia.delete(this.route('media.destroy', item.id), {
          preserveState: false
        });
      }
    },

    editItem(item) {
      this.$inertia.get(this.route('media.edit', item.id), {}, {
        preserveState: true
      });
    },
  }
}
</script>

<style>
.v-data-table {
  white-space: nowrap !important;
}
</style>